import { RouteComponentProps } from 'react-router-dom';

import BaseComponent from '@tock/shared/components/BaseComponent';
import connect, { DefaultConnectProps } from '@tock/shared/utils/connect';

class AccountRoute extends BaseComponent<DefaultConnectProps & RouteComponentProps> {
  componentDidMount() {
    this.props.actions.navigation.set({
      title: 'Profile',
    });
  }

  render() {
    return null;
  }
}

export default connect<RouteComponentProps>(AccountRoute);
